let dropdownLoaded = false

const { getElement } = window.BAO.Utils
class HeaderDropdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.lastTouched = null

    if (dropdownLoaded) return

    window.BAO.sectionRenderer
      .fetch('header', `${window.Shopify.routes.root}?view=dropdown`)
      .then(res => {
        dropdownLoaded = true

        const newDOM = window.BAO.sectionRenderer.convertToDOM(res.header)
        const myself = newDOM.querySelector('header-dropdown .hd-Banner_Items')
        this.querySelector('.hd-Banner_Items').outerHTML = myself.outerHTML
      })
      .catch(() => {})
  }

  setupListeners () {
    super.setupListeners()

    if (
      document.querySelector('[data-header-dropdown-el="menu-dropdown-toggle"]')
    ) {
      document
        .querySelectorAll('[data-header-dropdown-el="menu-dropdown-toggle"]')
        .forEach(menuToggleEl => {
          document.addEventListener(
            'click',
            this.handleToggleButtonClick.bind(this),
          )
        })
      this.els?.item?.elements.forEach(itemEl => {
        const menuDropdownEl = getElement(
          '[data-header-dropdown-el="menu-dropdown"]',
          { context: itemEl },
        )

        if (!menuDropdownEl) return

        const menuLinkEl = getElement('.hd-Banner_Link', { context: itemEl })

        this.listeners.add(
          menuLinkEl,
          'touchstart',
          this.handleToggleButtonTouchStart,
        )
      })
    }

    document.addEventListener('focusin', this.handleFocusIn.bind(this))

    document.addEventListener('focukeyupsin', this.handleEscapePress.bind(this))
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonTouchStart (event) {
    if (this.lastTouched === this.innerText) return

    event.preventDefault()

    this.lastTouched = this.innerText
  }

  /**
   * @param {ClickEvent} event
   *
   * @returns {void}
   */
  handleToggleButtonClick (event) {
    if (
      !event.target.closest('[data-header-dropdown-el="menu-dropdown-toggle"]')
    ) { return }

    const menuToggleEl = event.target
    const parentItemEl = menuToggleEl.closest(this.els?.item?.selector)
    if (!parentItemEl) return
    const menuDropdownEl = getElement(this.els?.['menu-dropdown']?.selector, {
      context: parentItemEl,
    })
    const isExpanded = menuDropdownEl.getAttribute('aria-expanded') === 'true'
    if (isExpanded) {
      menuToggleEl.removeAttribute('data-active')
      menuDropdownEl.removeAttribute('aria-expanded')
    } else {
      menuToggleEl.setAttribute('data-active', String(!isExpanded))
      menuDropdownEl.setAttribute('aria-expanded', String(!isExpanded))
    }
  }

  /**
   * @param {FocusInEvent} event
   *
   * @returns {void}
   */
  handleFocusIn (event) {
    if (
      event.target.closest(this.localName) &&
      !event.target.closest('[aria-expanded="true"]')
    ) {
      /* This ensures an expanded dropdown closes when the user tabs out of it but focus remains within the header-dropdown element */
      this.closeDropdowns()
    }

    if (!event.target.closest(this.localName)) {
      /* This ensures all dropdowns are closed when focus leaves the header-dropdown element */
      this.closeDropdowns()
    }
  }

  /**
   * @param {KeyboardEvent} event
   *
   * @returns {void}
   */
  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return
    this.closeDropdowns()
  }

  /**
   * @returns {void}
   */
  closeDropdowns () {
    if (this.els?.['menu-dropdown-toggle']?.exists) {
      this.els?.['menu-dropdown-toggle']?.elements.forEach(menuDropdownEl => {
        menuDropdownEl.removeAttribute('data-active')
      })
    }

    if (this.els?.['menu-dropdown']?.exists) {
      this.els?.['menu-dropdown']?.elements.forEach(menuDropdownEl => {
        menuDropdownEl.removeAttribute('aria-expanded')
      })
    }
  }
}

if (!customElements.get('header-dropdown')) {
  customElements.define('header-dropdown', HeaderDropdown)
}
